<header>
  <!-- Header content -->
</header>
<main class="page-content">
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</main>
<footer>
  <!-- Footer content -->
</footer>